<template>
    <van-datetime-picker 
        v-model="date" 
        type="datetime" 
        confirm-button-text="Confirm" 
        cancel-button-text="Cancel" 
        @confirm="confirmFn()" 
        @cancel="cancelFn()"
        :filter="filter"
        :max-date="maxDate"
        :min-date="minDate"
    />
</template>
<script>
    //import { validateBusinessAndHoliday} from '@/api/api'
    export default {
        components: {},
        props: {
            minDate: {
                type: Date
            },
            maxDate: {
                type: Date
            },
            date: {
                type: Date
            },
            confirm: {
                type: Function
            },
            cancel: {
                type: Function
            }
        },
        /*data () {
          return {
            store: {},
            holiday: {},
            businessHours: {},
            countBusiness: 0,
            countHoliday: 0
          }
        },
        created() {
          this.getData();
        },*/
        methods: {
            /*getData(){
            const getRouteQuery = () => {
            let tempParams = this.$route.query
            if (tempParams.h5api == undefined) {
              tempParams["h5api"] = 'on'
            }
            tempParams["do"] = 'validateBusinessAndHoliday' 
            return tempParams
            }
            const updateOption = () => {
            const queryParams = Object.assign(getRouteQuery(), {optype:'getBusinessAndHoliday'});
            console.log('queryParams DateTimePicker', queryParams)
            validateBusinessAndHoliday("/app/index.php", queryParams)
                    .then(res => {
                      console.log('Res data DatetimePicker.vue', res)
                      this.indexPage = res.data
                      this.store = this.indexPage.store
                      this.holiday = this.indexPage.holiday
                      this.businessHours = this.indexPage.businessHours
                      this.countBusiness = this.indexPage.countBusiness
                      this.countHoliday = this.indexPage.countHoliday
                      console.log('Date choosed from schedule datetime ', this.date)
                    })
                    .catch(error => {
                      // console.log('添加到购物车.error', error);
                    });
            };
            updateOption();
            },*/
            filter(type, options) {
              /*var dateHoliday = new Array()
              for (let j=0;j<this.countHoliday;j++){
                var keyHoliday = Object.keys(this.holiday.data[j])
                console.log('Holiday Date', keyHoliday)
                dateHoliday.push(keyHoliday)
                if (this.holiday.data[j][keyHoliday] != undefined){
                  var lengthHoliday = this.holiday.data[j][keyHoliday].length
                  for (let k=0;k<lengthHoliday;k++){
                    var holidayDate = this.holiday.data[j][keyHoliday][k]['date']
                    var startHoliday = this.holiday.data[j][keyHoliday][k]['start'].toString().padStart(4,"0")
                    var endHoliday = this.holiday.data[j][keyHoliday][k]['end'].toString().padStart(4,"0")
                    var hourStartHoliday = Number(startHoliday.substring(0,2))
                    var hourEndHoliday = Number(endHoliday.substring(0,2))
                    var minStartHoliday = Number(startHoliday.substring(2,4))
                    var minEndHoliday = Number(endHoliday.substring(2,4))
                    console.log('Hour start holiday: ' + hourStartHoliday + ' ,Hour End holiday: ', hourEndHoliday)
                    var getDateHoliday = new Date(holidayDate).getDate()
                    var getDateMonth = new Date(holidayDate).getMonth()

                    if (type === 'day'){
                      for (let y in options){
                        if (this.date.getMonth() + 1 == getDateMonth + 1){
                          if (options[y] == getDateHoliday){
                            if (startHoliday == '0000' && endHoliday == '2359'){
                              options.splice(y,1)
                              console.log('Month of Holiday',getDateMonth + 1 + ' Date of holiday', getDateHoliday + ' Start Hour of holiday', hourStartHoliday + ' End Hour of Holiday',hourEndHoliday)
                            }
                          }
                        }
                      }
                    }
                    if (type === 'hour'){
                      let currentMonth = this.date.getMonth() + 1
                      if (currentMonth == getDateMonth + 1){
                        if (this.date.getDate() == getDateHoliday){
                          let hourHoliday = new Array()
                          for (let i=hourStartHoliday;i<=hourEndHoliday;i++){
                            if (i == hourEndHoliday && minEndHoliday >= 0){
                              continue;
                            } else if (i == hourStartHoliday && minStartHoliday > 0){
                              continue;
                            } else {
                              hourHoliday.push(i)
                            }
                          }
                          console.log('Hour holiday that will be remove', hourHoliday)
                          for (let y in options){
                            for (let j in hourHoliday){
                              if (options[y] == hourHoliday[j]){
                                options.splice(y,1)
                              } else {
                                continue;
                              }
                            }
                          }
                        }
                      }
                    }
                    
                    if (type === 'minute') {
                      let currentMonth = this.date.getMonth() + 1
                      if (currentMonth == getDateMonth + 1){
                        if (this.date.getDate() == getDateHoliday){
                          let minHoliday = new Array();
                          if (this.date.getHours() == hourStartHoliday && minStartHoliday > 0){
                            for (let i=minStartHoliday;i<=59;i++){
                              minHoliday.push(i)
                            }
                            console.log('Minute removed from holiday start hour', minHoliday)
                          } else if (this.date.getHours() == hourEndHoliday && minEndHoliday > 0){
                            for (let i=0;i<=minEndHoliday;i++){
                              minHoliday.push(i)
                            }
                            console.log('Minute removed from holiday end hour',minHoliday)
                          }
                          for (let y in options){
                            for (let h in minHoliday){
                              if(options[y] == minHoliday[h]){
                                options.splice(y,1)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              var daysOpened = new Array()
              console.log('Type in filter ',type)
              for(let i=0;i<this.countBusiness;i++){
                var stringKey = Object.keys(this.businessHours.data[i]).toString().toUpperCase()
                daysOpened.push(stringKey)
                if (this.businessHours.data[i][stringKey] != undefined){
                  var lengthBusinessDay = this.businessHours.data[i][stringKey].length
                  for (let j=0;j<lengthBusinessDay;j++){
                    var startBusiness = this.businessHours.data[i][stringKey][j]['start'].toString().padStart(4,"0")
                    var endBusiness = this.businessHours.data[i][stringKey][j]['end'].toString().padStart(4,"0")
                    var hourStartBusiness = Number(startBusiness.substring(0,2))
                    var hourEndBusiness = Number(endBusiness.substring(0,2))
                    var minStartBusiness = Number(startBusiness.substring(2,4))
                    var minEndBusiness = Number(endBusiness.substring(2,4))
                    var daysInNumber = this.getDaysNumber(stringKey)
                    console.log('Start business ', startBusiness + ' end Business ' , endBusiness)

                    if (type === 'hour'){
                      if (this.date.getDay() == daysInNumber){
                        if (lengthBusinessDay > 0){
                          let busiHours = new Array()
                          for (let j =0;j<lengthBusinessDay;j++){
                            let startBusiness = this.businessHours.data[i][stringKey][j]['start'].toString().padStart(4,"0")
                            let endBusiness = this.businessHours.data[i][stringKey][j]['end'].toString().padStart(4,"0")
                            let hourStartBusiness = Number(startBusiness.substring(0,2))
                            let hourEndBusiness = Number(endBusiness.substring(0,2))
                            for (let y in options){
                              if (options[y] >= hourStartBusiness && options[y] <= hourEndBusiness){
                                busiHours.push(options[y])
                              }
                            }
                          } 
                          console.log('Business hours multiple time range hours ', busiHours)
                          options = options.filter((option) => busiHours.includes(option))
                        } else {
                          for (let y in options){
                            if (options[y] < hourStartBusiness){
                              options.splice(y,1)
                            }
                            if (options[y] > hourEndBusiness){
                              options.splice(y,1)
                            }
                          }
                        }
                      }
                    }
                    if (type === 'minute'){
                      if (this.date.getDay() == daysInNumber){
                        let minBusiness = new Array()
                        if (this.date.getHours() == hourStartBusiness){
                          for (let i=0;i<minStartBusiness;i++){
                            minBusiness.push(i)
                          }
                        } else if (this.date.getHours() == hourEndBusiness){
                          for (let i=0;i<=59;i++){
                            if (i>minEndBusiness){
                              minBusiness.push(i)
                            }
                          }
                        }
                        for (let y in options){
                          for (let h in minBusiness){
                            if (options[y] == minBusiness[h]){
                              options.splice(y,1)
                            }
                          }
                        }
                        options = options.filter((option) => option % 10 === 0)
                      }
                    }
                  }
                } 
              }
              console.log('Days Opened', daysOpened)
              let days = ['SUNDAY','MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY']
              let daysOpenedLength = daysOpened.length
              let daysLength = days.length
              for (let i=0;i<daysOpenedLength;i++){
                for (let j=0;j<daysLength;j++){
                  if (daysOpened[i] == days[j]){
                    days.splice(j,1)
                  }
                }
              }
              console.log('Days closed', days)
              let daysClosed = new Array()
              for (let i=0;i<daysLength;i++){
                let daysInWeek = this.getDaysNumber(days[i])
                daysClosed.push(daysInWeek);
              }
              let daysInMonth = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0).getDate();
              let daysClosedLength = daysClosed.length
              console.log('Days in month', daysInMonth)
              for(let i=1;i<=daysInMonth;i++){ 
                let newDate = new Date(this.date.getFullYear(), this.date.getMonth(), i)
                for (let j=0;j<daysClosedLength;j++){
                  if (newDate.getDay() == daysClosed[j]){
                    if(type === 'day'){
                      for(let y in options){
                        if (options[y] == newDate.getDate()){
                          options.splice(y,1)
                          console.log('Date closed for the month',newDate.getDate());
                        }
                      }
                    } 
                  }
                }
              }
              if (type === 'year'){
                if (new Date().getMonth() < 10){
                  return options.filter((option) => option == options[0])
                } else {
                  return options.filter((option) => option < options[2])
                }
              }*/
              if (type === 'minute'){
                return options.filter((option) => option % 10 === 0)
              }
              return options;
            },
            /*getDaysNumber(stringKey) {
              if (stringKey == 'SUNDAY'){
                return 0;
              } else if (stringKey == 'MONDAY'){
                return 1;
              } else if (stringKey == 'TUESDAY'){
                return 2;
              } else if (stringKey == 'WEDNESDAY'){
                return 3;
              } else if (stringKey == 'THURSDAY'){
                return 4;
              } else if (stringKey == 'FRIDAY'){
                return 5;
              } else if (stringKey == 'SATURDAY'){
                return 6;
              }
            },*/
            confirmFn() {
                console.log('Selected DateTime>>>', this.date);
                this.confirm(this.date);
            },
            cancelFn(chosedDatetime) {
                this.cancel();
            },
        }
    }
</script>